import { useState, createContext, useContext, useEffect } from "react";
import { ChainResponse } from "baaanggg";
import { useChains } from "@hooks/ChainsHook";
import { getChainRegistryChainInfo, getChainRegistryAssetList } from "@goblinhunt/cosmes/registry";

const SelectedChainContext = createContext<{
  selectedChain?: ChainResponse,
}>({});

export const useSelectedChain = () => useContext(SelectedChainContext);

export const ChainSelector = ({ children }: { children: React.ReactNode; }) => {
  const chains = useChains()
  const [chain, setChain] = useState<ChainResponse>();

  const getChainCosmes = async () => {
    // let chain = await getChainRegistryChainInfo("terra");
    // console.log(chain)
    
    const terraClassicChain: ChainResponse = {
      id: "ea073e80-3e72-4dc1-878c-b5b13ed48249",
      name: "Terra Classic",
      prefix: "terra",
      imageUrl: "https://assets.terra.money/icon/60/columbus.png",
      chainId: "columbus-5",
      lcdUrl: "https://terra-classic-lcd.publicnode.com", // FIXED
      websocketUrl: "wss://columbus-ws.terra.dev/websocket",
      isClassic: true,
      baseAsset: "uluna",
      gasAdjustment: 1.75,
      gasPrices: JSON.stringify({uluna:'0.15',ustc:'0.15'}), // ✅ OK,
      txExplorer: "https://finder.terra.money/classic/tx",
      addressExplorer: "https://finder.terra.money/classic/address",
      marketContract: "terra1gg9p33qkcmkckqxm55f8ljve9v4tx8w7k2d6qs",
      tax: 0.0025,
      createdAt: new Date("2023-01-01T00:00:00.000Z"),
      updatedAt: new Date(),
    }
    setChain(terraClassicChain)

  }


  useEffect(() => {
    getChainCosmes()
  }, [chains]);

  return (
    <SelectedChainContext.Provider value={{
      selectedChain: chain
    }}>
      <>{children}</>
    </SelectedChainContext.Provider>
  );
};
